import { IntlShape } from 'react-intl';

import { validateDateRange } from './validateDateRange';
import { DateRange, FormattedDateRange } from './constants';

export const formatDateRange = (
  customDateRange: DateRange,
  $t: IntlShape['$t']
): FormattedDateRange => {
  const { minDateErrorMessage, maxDateErrorMessage, isSharedError } =
    validateDateRange(customDateRange);

  return {
    minDate: {
      value: customDateRange.minDate as string,
      error: minDateErrorMessage ? $t(minDateErrorMessage) : '',
    },
    maxDate: {
      value: customDateRange.maxDate as string,
      error: maxDateErrorMessage ? $t(maxDateErrorMessage) : '',
    },
    isSharedError,
  };
};
